/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getMessage = /* GraphQL */ `
  query GetMessage($clubChannelId: String!, $createdAt: String!) {
    getMessage(clubChannelId: $clubChannelId, createdAt: $createdAt) {
      id
      userId
      username
      content
      replyContent
      clubChannelId
      clubId
      createdAt
      isSent
    }
  }
`;
export const listMessages = /* GraphQL */ `
  query ListMessages(
    $filter: TableMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        username
        content
        replyContent
        clubChannelId
        clubId
        createdAt
        isSent
      }
      nextToken
    }
  }
`;
